// import React from 'react';
// import ClassroomHeader from '../components/ClassroomHeader';
// import UserOverview from 'views/admin/main/users/overview';
// import ClassroomList from 'views/admin/main/users/classroom';

// /**
//  * The main container for the classroom management page.
//  * It sets up a consistent layout and background for the components within.
//  */
// const Classroom = () => {
//   return (
//     // Sets a consistent background and padding for the entire page view.
//     <div className="classroom-container ">
      
//         
//         {/* Render the StudentList component - This comment is preserved from original */}
//         <ClassroomHeader />
//         {/* <UserOverview /> */}
//         <ClassroomList />

//     </div>
//   );
// };

// export default Classroom;



import React from 'react';
import ClassroomHeader from '../components/ClassroomHeader';
import ClassroomList from 'views/admin/main/users/classroom';

/**
 * The main container for the classroom management page.
 * It sets up a consistent layout and background for the components within.
 */
const Classroom = () => {
  return (
    // Sets a consistent background and padding for the entire page view.
    <div className="classroom-container pt-[60px] lg:pt-[20px]">
      <ClassroomHeader />
      <ClassroomList />
    </div>
  );
};

export default Classroom;